/* Onys: sandwich menu + reveal on scroll. No dependencies. */
(function () {
  var root = document.documentElement;
  root.classList.add('onys-js');

  /* weak devices or data-saver: fewer background layers */
  var conn = navigator.connection || {};
  if ((navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 2) || conn.saveData) {
    root.classList.add('onys-lite');
  }

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  /* ---------- menu ---------- */
  function initMenu() {
    var toggle = document.querySelector('[data-onys-menu-toggle]');
    var menu = document.querySelector('[data-onys-menu]');
    var header = document.querySelector('[data-onys-header]');
    if (!toggle || !menu || toggle.hasAttribute('data-onys-bound')) return;
    toggle.setAttribute('data-onys-bound', '');

    var isOpen = false;
    // label in the current site language (data-label-open-it / -en), falling back to the plain one
    function label(kind) {
      var lang = window.onysLang ? window.onysLang() : 'it';
      return toggle.getAttribute('data-label-' + kind + '-' + lang) || toggle.getAttribute('data-label-' + kind) || 'Menu';
    }
    function syncLabel() { toggle.setAttribute('aria-label', label(isOpen ? 'close' : 'open')); }
    document.addEventListener('onys:lang', syncLabel);
    syncLabel();

    function open() {
      isOpen = true;
      menu.classList.add('is-open');
      root.classList.add('onys-menu-open');
      toggle.setAttribute('aria-expanded', 'true');
      syncLabel();
      var first = menu.querySelector('a[href]');
      if (first) {
        window.setTimeout(function () {
          if (isOpen) first.focus({ preventScroll: true });
        }, 450);
      }
    }

    function close(returnFocus) {
      isOpen = false;
      menu.classList.remove('is-open');
      root.classList.remove('onys-menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      syncLabel();
      if (returnFocus) toggle.focus({ preventScroll: true });
    }

    toggle.addEventListener('click', function () {
      if (isOpen) close(true);
      else open();
    });

    menu.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('a[href]') : null;
      if (link) close(false);
    });

    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') {
        close(true);
        return;
      }
      if (e.key !== 'Tab') return;

      var items = [].slice.call((header || document).querySelectorAll(FOCUSABLE))
        .concat([].slice.call(menu.querySelectorAll(FOCUSABLE)));
      if (!items.length) return;
      var i = items.indexOf(document.activeElement);
      if (e.shiftKey && i <= 0) {
        e.preventDefault();
        items[items.length - 1].focus();
      } else if (!e.shiftKey && i === items.length - 1) {
        e.preventDefault();
        items[0].focus();
      }
    });

    /* desktop -> mobile resize etc: nothing to do, same menu everywhere */
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var els = [].slice.call(document.querySelectorAll('[data-onys-reveal]:not(.is-in)'));
    if (!els.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var inEditor = window.Shopify && window.Shopify.designMode;
    if (reduce || inEditor || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- backdrop: only animate while visible ---------- */
  function initBackdrops() {
    var els = [].slice.call(document.querySelectorAll('[data-onys-backdrop]:not([data-onys-bound])'));
    if (!els.length || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('is-paused', !entry.isIntersecting);
      });
    }, { threshold: 0 });

    els.forEach(function (el) {
      el.setAttribute('data-onys-bound', '');
      io.observe(el);
    });
  }

  /* ---------- videos: nothing loads or plays until asked ---------- */
  function resetVideo(video) {
    var media = video.closest('.onys-work__media');
    video.pause();
    video.controls = false;
    video.muted = true;
    if (media) media.classList.remove('is-playing');
  }

  function initVideos() {
    var buttons = [].slice.call(document.querySelectorAll('[data-onys-play]:not([data-onys-bound])'));
    buttons.forEach(function (button) {
      button.setAttribute('data-onys-bound', '');
      var media = button.closest('.onys-work__media');
      var video = media && media.querySelector('video[data-onys-video]');
      if (!video) return;

      button.addEventListener('click', function () {
        [].slice.call(document.querySelectorAll('video[data-onys-video]')).forEach(function (other) {
          if (other !== video) resetVideo(other);
        });
        video.muted = false;
        video.controls = true;
        media.classList.add('is-playing');
        var attempt = video.play();
        if (attempt && attempt.catch) {
          attempt.catch(function () {
            /* the browser refused to autoplay: controls are visible, so the user can press play */
          });
        }
        video.focus({ preventScroll: true });
      });

      video.addEventListener('ended', function () {
        resetVideo(video);
        video.currentTime = 0;
      });
    });
  }

  /* ---------- product gallery: one photo at a time + zoom lightbox ---------- */
  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  function initGallery() {
    var roots = [].slice.call(document.querySelectorAll('[data-onys-gallery]:not([data-onys-bound])'));

    roots.forEach(function (root) {
      root.setAttribute('data-onys-bound', '');

      var section = root.closest('.onys-product') || document;
      var track = root.querySelector('[data-onys-track]');
      var slides = track ? [].slice.call(track.children) : [];
      var total = slides.length;
      if (!total) return;

      var prev = root.querySelector('[data-onys-prev]');
      var next = root.querySelector('[data-onys-next]');
      var counter = root.querySelector('[data-onys-count]');
      var thumbs = [].slice.call(root.querySelectorAll('[data-onys-go]'));
      var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      var current = 0;
      var locked = false;
      var lockTimer = 0;

      function slideWidth() {
        return track.clientWidth || 1;
      }

      function setCurrent(i) {
        current = i;
        if (counter) counter.textContent = i + 1 + ' / ' + total;
        if (prev) prev.setAttribute('aria-disabled', i === 0 ? 'true' : 'false');
        if (next) next.setAttribute('aria-disabled', i === total - 1 ? 'true' : 'false');

        thumbs.forEach(function (thumb, n) {
          if (n === i) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });

        /* start loading the neighbours so the next arrow press never shows a blank */
        [i - 1, i + 1].forEach(function (n) {
          var img = slides[n] && slides[n].querySelector('img');
          if (img && img.loading === 'lazy') img.loading = 'eager';
        });

        var active = thumbs[i];
        var strip = active && active.closest('.onys-gallery__thumbs');
        if (strip) {
          var a = active.getBoundingClientRect();
          var b = strip.getBoundingClientRect();
          strip.scrollTo({ left: strip.scrollLeft + (a.left - b.left) - (b.width - a.width) / 2, behavior: reduce ? 'auto' : 'smooth' });
        }
      }

      function goTo(i, instant) {
        i = clamp(i, 0, total - 1);
        var smooth = !(reduce || instant);
        locked = true;
        window.clearTimeout(lockTimer);
        lockTimer = window.setTimeout(function () {
          locked = false;
        }, smooth ? 750 : 80);
        track.scrollTo({ left: i * slideWidth(), behavior: smooth ? 'smooth' : 'auto' });
        setCurrent(i);
      }

      /* a swipe on a phone scrolls the track natively; follow it */
      var raf = 0;
      track.addEventListener(
        'scroll',
        function () {
          if (locked) return;
          window.cancelAnimationFrame(raf);
          raf = window.requestAnimationFrame(function () {
            var i = clamp(Math.round(track.scrollLeft / slideWidth()), 0, total - 1);
            if (i !== current) setCurrent(i);
          });
        },
        { passive: true }
      );

      if (prev) {
        prev.addEventListener('click', function () {
          if (prev.getAttribute('aria-disabled') !== 'true') goTo(current - 1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          if (next.getAttribute('aria-disabled') !== 'true') goTo(current + 1);
        });
      }
      thumbs.forEach(function (thumb, n) {
        thumb.addEventListener('click', function () {
          goTo(n);
        });
      });

      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          goTo(current - 1);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          goTo(current + 1);
        } else if (e.key === 'Home') {
          e.preventDefault();
          goTo(0);
        } else if (e.key === 'End') {
          e.preventDefault();
          goTo(total - 1);
        }
      });

      var resizeTimer = 0;
      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          track.scrollTo({ left: current * slideWidth(), behavior: 'auto' });
        }, 120);
      });

      /* choosing a colour shows that colour's photo */
      var select = section.querySelector('[data-onys-variant-select]');
      function syncToVariant(instant) {
        var option = select && select.options[select.selectedIndex];
        var id = option && option.getAttribute('data-media-id');
        if (!id) return;
        for (var n = 0; n < slides.length; n++) {
          if (slides[n].getAttribute('data-media-id') === id) {
            if (n !== current) goTo(n, instant);
            break;
          }
        }
      }
      if (select) {
        select.addEventListener('change', function () {
          syncToVariant(false);
        });
      }

      setCurrent(0);

      /* ---------- lightbox with zoom ---------- */
      var dlg = section.querySelector('[data-onys-lightbox]');
      if (!dlg || typeof dlg.showModal !== 'function') return;

      var stage = dlg.querySelector('[data-onys-stage]');
      var big = dlg.querySelector('[data-onys-lbimg]');
      var lbCount = dlg.querySelector('[data-onys-lbcount]');
      var lbPrev = dlg.querySelector('[data-onys-lbprev]');
      var lbNext = dlg.querySelector('[data-onys-lbnext]');
      var zoomIn = dlg.querySelector('[data-onys-zoomin]');
      var zoomOut = dlg.querySelector('[data-onys-zoomout]');
      var closeBtn = dlg.querySelector('[data-onys-close]');

      var MIN = 1;
      var MAX = 4;
      var idx = 0;
      var opener = null;
      var st = { s: 1, x: 0, y: 0 };
      var pointers = {};
      var pinch = null;
      var moved = 0;
      var lastTap = null;

      function apply(animate) {
        big.style.transition = animate && !reduce ? 'transform 0.28s cubic-bezier(0.2, 0.8, 0.2, 1)' : 'none';
        big.style.transform = 'translate3d(' + st.x + 'px,' + st.y + 'px,0) scale(' + st.s + ')';
        stage.classList.toggle('is-zoomed', st.s > 1.001);
        if (zoomIn) zoomIn.setAttribute('aria-disabled', st.s >= MAX - 0.001 ? 'true' : 'false');
        if (zoomOut) zoomOut.setAttribute('aria-disabled', st.s <= MIN + 0.001 ? 'true' : 'false');
      }

      /* size of the photo as displayed at scale 1 (object-fit: contain inside the stage) */
      function shown() {
        var sw = stage.clientWidth;
        var sh = stage.clientHeight;
        var ratio = (big.naturalWidth || 1) / (big.naturalHeight || 1);
        return { w: Math.min(sw, sh * ratio), h: Math.min(sh, sw / ratio), sw: sw, sh: sh };
      }

      function constrain() {
        var c = shown();
        var bx = Math.max(0, (c.w * st.s - c.sw) / 2);
        var by = Math.max(0, (c.h * st.s - c.sh) / 2);
        st.x = clamp(st.x, -bx, bx);
        st.y = clamp(st.y, -by, by);
      }

      /* zoom to scale ns keeping the point under (cx, cy) fixed */
      function zoomTo(ns, cx, cy, animate) {
        ns = clamp(ns, MIN, MAX);
        var r = stage.getBoundingClientRect();
        var px = cx - (r.left + r.width / 2);
        var py = cy - (r.top + r.height / 2);
        var k = ns / st.s;
        st.x = px - (px - st.x) * k;
        st.y = py - (py - st.y) * k;
        st.s = ns;
        if (ns <= 1.001) {
          st.x = 0;
          st.y = 0;
        }
        constrain();
        apply(animate);
      }

      function stageCenter() {
        var r = stage.getBoundingClientRect();
        return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
      }

      function show(i) {
        idx = clamp(i, 0, total - 1);
        var slide = slides[idx];
        var btn = slide.querySelector('[data-onys-open]');
        var img = slide.querySelector('img');
        var full = btn.getAttribute('data-full');
        var mine = idx;

        st.s = 1;
        st.x = 0;
        st.y = 0;
        apply(false);

        big.alt = img ? img.alt : '';
        big.src = (img && (img.currentSrc || img.src)) || full; /* already cached: shows instantly */
        var loader = new Image();
        loader.onload = function () {
          if (mine === idx) big.src = full; /* swap to the sharp version */
        };
        loader.src = full;

        if (lbCount) lbCount.textContent = idx + 1 + ' / ' + total;
        if (lbPrev) lbPrev.setAttribute('aria-disabled', idx === 0 ? 'true' : 'false');
        if (lbNext) lbNext.setAttribute('aria-disabled', idx === total - 1 ? 'true' : 'false');

        [idx - 1, idx + 1].forEach(function (n) {
          var b = slides[n] && slides[n].querySelector('[data-onys-open]');
          if (b) new Image().src = b.getAttribute('data-full');
        });

        goTo(idx, true); /* keep the gallery behind the dialog in sync */
      }

      function step(d) {
        var n = idx + d;
        if (n < 0 || n > total - 1) return;
        show(n);
      }

      big.addEventListener('load', function () {
        constrain();
        apply(false);
      });

      root.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('[data-onys-open]') : null;
        if (!btn) return;
        opener = btn;
        dlg.showModal();
        root_lock(true);
        show(slides.indexOf(btn.closest('.onys-gallery__slide')));
      });

      function root_lock(on) {
        document.documentElement.classList.toggle('onys-lightbox-open', on);
      }

      dlg.addEventListener('close', function () {
        root_lock(false);
        pointers = {};
        pinch = null;
        if (opener) opener.focus({ preventScroll: true });
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          dlg.close();
        });
      }
      if (lbPrev) {
        lbPrev.addEventListener('click', function () {
          step(-1);
        });
      }
      if (lbNext) {
        lbNext.addEventListener('click', function () {
          step(1);
        });
      }
      if (zoomIn) {
        zoomIn.addEventListener('click', function () {
          var c = stageCenter();
          zoomTo(st.s * 1.6, c.x, c.y, true);
        });
      }
      if (zoomOut) {
        zoomOut.addEventListener('click', function () {
          var c = stageCenter();
          zoomTo(st.s / 1.6, c.x, c.y, true);
        });
      }

      dlg.addEventListener('keydown', function (e) {
        var c = stageCenter();
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          step(-1);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          step(1);
        } else if (e.key === '+' || e.key === '=') {
          e.preventDefault();
          zoomTo(st.s * 1.6, c.x, c.y, true);
        } else if (e.key === '-' || e.key === '_') {
          e.preventDefault();
          zoomTo(st.s / 1.6, c.x, c.y, true);
        } else if (e.key === '0') {
          e.preventDefault();
          zoomTo(1, c.x, c.y, true);
        }
      });

      /* wheel and trackpad pinch */
      stage.addEventListener(
        'wheel',
        function (e) {
          e.preventDefault();
          var delta = e.deltaMode === 1 ? e.deltaY * 16 : e.deltaY;
          zoomTo(st.s * Math.exp(-delta * (e.ctrlKey ? 0.01 : 0.0018)), e.clientX, e.clientY, false);
        },
        { passive: false }
      );

      /* pointer gestures: drag to pan, two fingers to pinch, swipe to change photo, tap to zoom */
      stage.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        stage.setPointerCapture(e.pointerId);
        pointers[e.pointerId] = { x: e.clientX, y: e.clientY, sx: e.clientX, sy: e.clientY, t: Date.now() };
        var ids = Object.keys(pointers);
        if (ids.length === 1) moved = 0;
        if (ids.length === 2) {
          var a = pointers[ids[0]];
          var b = pointers[ids[1]];
          pinch = {
            d0: Math.hypot(a.x - b.x, a.y - b.y) || 1,
            s0: st.s,
            mx: (a.x + b.x) / 2,
            my: (a.y + b.y) / 2,
          };
        }
      });

      stage.addEventListener('pointermove', function (e) {
        var p = pointers[e.pointerId];
        if (!p) return;
        var dx = e.clientX - p.x;
        var dy = e.clientY - p.y;
        p.x = e.clientX;
        p.y = e.clientY;
        var ids = Object.keys(pointers);

        if (ids.length === 2 && pinch) {
          var a = pointers[ids[0]];
          var b = pointers[ids[1]];
          var d = Math.hypot(a.x - b.x, a.y - b.y);
          var mx = (a.x + b.x) / 2;
          var my = (a.y + b.y) / 2;
          st.x += mx - pinch.mx;
          st.y += my - pinch.my;
          pinch.mx = mx;
          pinch.my = my;
          zoomTo(pinch.s0 * (d / pinch.d0), mx, my, false);
          moved = 99;
        } else if (ids.length === 1) {
          moved = Math.max(moved, Math.hypot(e.clientX - p.sx, e.clientY - p.sy));
          if (st.s > 1.001) {
            st.x += dx;
            st.y += dy;
            constrain();
            apply(false);
            stage.classList.add('is-panning');
          }
        }
      });

      function endPointer(e) {
        var p = pointers[e.pointerId];
        if (!p) return;
        delete pointers[e.pointerId];
        stage.classList.remove('is-panning');
        var left = Object.keys(pointers).length;

        if (left === 1) {
          pinch = null;
          return;
        }
        if (left > 0) return;

        if (pinch) {
          pinch = null;
          if (st.s < 1.05) zoomTo(1, e.clientX, e.clientY, true);
          return;
        }
        if (e.type !== 'pointerup') return;

        var dx = e.clientX - p.sx;
        var dy = e.clientY - p.sy;
        if (st.s <= 1.001 && Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          step(dx < 0 ? 1 : -1);
          return;
        }
        if (moved >= 8) return;

        if (e.pointerType === 'mouse') {
          zoomTo(st.s > 1.001 ? 1 : 2.5, e.clientX, e.clientY, true);
        } else {
          var now = Date.now();
          if (lastTap && now - lastTap.t < 320 && Math.hypot(e.clientX - lastTap.x, e.clientY - lastTap.y) < 40) {
            zoomTo(st.s > 1.001 ? 1 : 2.5, e.clientX, e.clientY, true);
            lastTap = null;
          } else {
            lastTap = { t: now, x: e.clientX, y: e.clientY };
          }
        }
      }
      stage.addEventListener('pointerup', endPointer);
      stage.addEventListener('pointercancel', endPointer);

      window.addEventListener('resize', function () {
        if (!dlg.open) return;
        constrain();
        apply(false);
      });

      syncToVariant(true);
    });
  }

  /* ---------- pointer light: a soft glow that follows the mouse (desktop only) ---------- */
  function initSpot() {
    var fine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!fine || reduce) return;

    [].slice.call(document.querySelectorAll('[data-onys-backdrop]:not([data-onys-spot])')).forEach(function (backdrop) {
      var spot = backdrop.querySelector('.onys-backdrop__spot');
      var host = backdrop.parentElement;
      if (!spot || !host) return;
      backdrop.setAttribute('data-onys-spot', '');

      var box = host.getBoundingClientRect();
      var tx = box.width / 2;
      var ty = box.height * 0.4;
      var x = tx;
      var y = ty;
      var raf = 0;

      function tick() {
        x += (tx - x) * 0.1;
        y += (ty - y) * 0.1;
        spot.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
        if (Math.abs(tx - x) > 0.4 || Math.abs(ty - y) > 0.4) raf = window.requestAnimationFrame(tick);
        else raf = 0;
      }

      host.addEventListener(
        'pointermove',
        function (e) {
          if (e.pointerType && e.pointerType !== 'mouse') return;
          var r = host.getBoundingClientRect();
          tx = e.clientX - r.left;
          ty = e.clientY - r.top;
          if (!raf) raf = window.requestAnimationFrame(tick);
        },
        { passive: true }
      );
    });
  }

  /* ---------- scroll split card: writes --p (0..1) while the section is on screen ---------- */
  function initSplit() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return; /* without .is-live the chapters simply show as cards */

    [].slice.call(document.querySelectorAll('[data-onys-split]:not([data-onys-bound])')).forEach(function (section) {
      section.setAttribute('data-onys-bound', '');
      section.classList.add('is-live');

      var last = -1;
      var ticking = false;
      var active = true;

      function update() {
        ticking = false;
        var r = section.getBoundingClientRect();
        var range = r.height - window.innerHeight;
        var p = range > 0 ? clamp(-r.top / range, 0, 1) : 1;
        if (Math.abs(p - last) > 0.0004) {
          last = p;
          section.style.setProperty('--p', p.toFixed(4));
        }
      }

      function request() {
        if (!active || ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }

      window.addEventListener('scroll', request, { passive: true });
      window.addEventListener('resize', function () {
        last = -1;
        request();
      });

      /* only do work while the section is near the screen */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries) {
            active = entries[0].isIntersecting;
            if (active) request();
          },
          { rootMargin: '100% 0px 100% 0px' }
        ).observe(section);
      }

      update();
    });
  }

  /* ---------- cart page: quantities in place, numbers that roll ---------- */
  function initCart() {
    var root = document.querySelector('[data-onys-cart]:not([data-onys-bound])');
    if (!root) return;
    root.setAttribute('data-onys-bound', '');

    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var routes = window.routes || {};
    var updateUrl = routes.cart_update_url || '/cart/update.js';
    var cartUrl = routes.cart_url || '/cart';
    var sectionId = root.getAttribute('data-section-id');
    var checkoutUrl = root.getAttribute('data-checkout-url') || '/checkout';
    var live = root.querySelector('[data-onys-live]');

    var pending = {};
    var notePending = null;
    var timer = 0;
    var noteTimer = 0;
    var inflight = Promise.resolve(true);
    var removed = 0;
    var barObserver = null;

    function q(sel, ctx) {
      return (ctx || root).querySelector(sel);
    }
    function all(sel, ctx) {
      return [].slice.call((ctx || root).querySelectorAll(sel));
    }
    function lineByKey(key, ctx) {
      return all('.onys-cart__line', ctx).filter(function (l) {
        return l.getAttribute('data-key') === key;
      })[0];
    }
    function rollByKey(key, ctx) {
      return all('[data-roll]', ctx).filter(function (el) {
        return el.getAttribute('data-roll') === key;
      })[0];
    }

    function siteLang() { return window.onysLang ? window.onysLang() : 'it'; }
    function cartMsg(kind) { return root.getAttribute('data-msg-' + kind + '-' + siteLang()) || root.getAttribute('data-msg-' + kind + '-it'); }

    function setBusy(on) {
      root.classList.toggle('is-busy', on);
    }

    function announce(text) {
      if (!live || !text) return;
      live.textContent = '';
      window.setTimeout(function () {
        live.textContent = text;
      }, 40);
    }

    /* the old value slides up and out while the new one slides in */
    function roll(el, text) {
      if (!el) return;
      var current = el.getAttribute('data-value') || el.textContent.trim();
      if (current === text) return;
      el.setAttribute('data-value', text);
      if (reduce) {
        el.textContent = text;
        return;
      }
      el.textContent = '';
      var wrap = document.createElement('span');
      wrap.className = 'onys-roll';
      var oldSpan = document.createElement('span');
      oldSpan.className = 'onys-roll__old';
      oldSpan.setAttribute('aria-hidden', 'true');
      oldSpan.textContent = current;
      var newSpan = document.createElement('span');
      newSpan.className = 'onys-roll__new';
      newSpan.textContent = text;
      wrap.appendChild(oldSpan);
      wrap.appendChild(newSpan);
      el.appendChild(wrap);
      window.setTimeout(function () {
        if (el.getAttribute('data-value') === text) el.textContent = text;
      }, 450);
    }

    function post(url, body) {
      return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) {
            var err = new Error(data.description || data.message || 'cart error');
            err.data = data;
            throw err;
          }
          return data;
        });
      });
    }

    /* the section is the single source of truth: fetch it and read the numbers from it */
    function fetchSection() {
      var url = cartUrl + (cartUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
      return fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          return new DOMParser().parseFromString(html, 'text/html').querySelector('[data-onys-cart]');
        });
    }

    function observeBar() {
      if (barObserver) barObserver.disconnect();
      /* the bar is only redundant once the summary's own checkout button is on screen */
      var target = q('.onys-cart__checkout');
      var bar = q('[data-onys-bar]');
      if (!target || !bar || !('IntersectionObserver' in window)) return;
      barObserver = new IntersectionObserver(
        function (entries) {
          bar.classList.toggle('is-visible', !entries[0].isIntersecting);
        },
        { rootMargin: '0px 0px -72px 0px' }
      );
      barObserver.observe(target);
    }

    function syncHeader(count) {
      all('.onys-header__count', document).forEach(function (el) {
        roll(el, String(count));
      });
    }

    function collapse(line) {
      var focused = line.contains(document.activeElement);
      var finish = function () {
        if (!line.parentNode) return;
        line.remove();
        if (focused) {
          var next = q('.onys-cart__line [data-onys-qty]') || q('.onys-cart__title');
          if (next && next.focus) next.focus({ preventScroll: true });
        }
      };
      if (reduce) {
        finish();
        return;
      }
      line.classList.add('is-removing');
      line.addEventListener('transitionend', function te(e) {
        if (e.target === line && e.propertyName === 'grid-template-rows') {
          line.removeEventListener('transitionend', te);
          finish();
        }
      });
      window.setTimeout(finish, 800);
    }

    function swapBody(next) {
      var body = q('.onys-cart__body');
      var fresh = next.querySelector('.onys-cart__body');
      var chip = q('.onys-cart__count');
      if (chip) {
        chip.style.transition = 'opacity 0.25s ease';
        chip.style.opacity = '0';
        window.setTimeout(function () {
          if (chip.parentNode) chip.remove();
        }, 280);
      }
      body.classList.add('is-swapping');
      window.setTimeout(
        function () {
          body.innerHTML = fresh.innerHTML;
          body.classList.remove('is-swapping');
          observeBar();
        },
        reduce ? 0 : 240
      );
    }

    function apply(next) {
      var count = parseInt(next.getAttribute('data-item-count'), 10) || 0;
      root.setAttribute('data-item-count', String(count));
      syncHeader(count);

      var nextEmpty = !next.querySelector('.onys-cart__layout');
      var nowEmpty = !q('.onys-cart__layout');
      if (nextEmpty && !nowEmpty) {
        swapBody(next);
        return;
      }
      if (nextEmpty) return;

      roll(q('[data-roll="count"]'), (rollByKey('count', next) || { textContent: '' }).textContent.trim());
      var countLabel = q('[data-count-label]'), freshLabel = next.querySelector('[data-count-label]');
      if (countLabel && freshLabel) countLabel.innerHTML = freshLabel.innerHTML;

      all('.onys-cart__line').forEach(function (line) {
        var key = line.getAttribute('data-key');
        var fresh = lineByKey(key, next);
        if (!fresh) {
          collapse(line);
          return;
        }
        var input = q('[data-onys-qty]', line);
        var freshInput = q('[data-onys-qty]', fresh);
        if (input && freshInput && pending[key] === undefined) {
          input.value = freshInput.value;
          input.setAttribute('value', freshInput.value);
          var minus = q('[data-onys-minus]', line);
          if (minus) minus.setAttribute('aria-disabled', parseInt(freshInput.value, 10) <= 1 ? 'true' : 'false');
        }
        var meta = q('.onys-cart__price-meta', line);
        var freshMeta = q('.onys-cart__price-meta', fresh);
        if (meta && freshMeta && meta.innerHTML.trim() !== freshMeta.innerHTML.trim()) meta.innerHTML = freshMeta.innerHTML;
        var err = q('.onys-cart__error', line);
        if (err) err.hidden = true;
      });

      /* the discount rows can appear or disappear: swap that block, roll everything else */
      var dyn = q('[data-onys-dynamic="discounts"]');
      var freshDyn = q('[data-onys-dynamic="discounts"]', next);
      if (dyn && freshDyn && !!dyn.querySelector('dl') !== !!freshDyn.querySelector('dl')) dyn.innerHTML = freshDyn.innerHTML;

      all('[data-roll]').forEach(function (el) {
        var fresh = rollByKey(el.getAttribute('data-roll'), next);
        if (fresh) roll(el, fresh.textContent.trim());
      });
    }

    function sync() {
      return fetchSection().then(function (next) {
        if (!next) {
          window.location.reload();
          return;
        }
        apply(next);
      });
    }

    function onError(err, keys) {
      // Shopify's own reason is in the store language (English): use it only when the site is in English
      var shopMsg = err && err.data && (err.data.message || err.data.description);
      var msg = (siteLang() === 'en' && shopMsg) || cartMsg('error');
      return fetchSection().then(function (next) {
        if (next) {
          q('.onys-cart__body').innerHTML = next.querySelector('.onys-cart__body').innerHTML;
          root.setAttribute('data-item-count', next.getAttribute('data-item-count') || '0');
          syncHeader(parseInt(next.getAttribute('data-item-count'), 10) || 0);
          observeBar();
        }
        var shown = false;
        (keys || []).forEach(function (key) {
          var line = lineByKey(key);
          var box = line && q('.onys-cart__error', line);
          if (box) {
            box.textContent = msg;
            box.hidden = false;
            shown = true;
          }
        });
        announce(msg);
        void shown;
      }).catch(function () {
        /* even the re-sync failed: say so, the next change starts from a clean queue */
        announce(msg);
      });
    }

    function flush() {
      window.clearTimeout(timer);
      window.clearTimeout(noteTimer);
      var updates = pending;
      var note = notePending;
      pending = {};
      notePending = null;
      var keys = Object.keys(updates);
      if (!keys.length && note === null) {
        return inflight.then(function () {
          return true;
        });
      }
      var body = {};
      if (keys.length) body.updates = updates;
      if (note !== null) body.note = note;
      var removals = keys.filter(function (k) {
        return updates[k] === 0;
      }).length;

      inflight = inflight
        .then(function () {
          return post(updateUrl, body)
            .then(sync)
            .then(function () {
              announce(cartMsg(removals ? 'removed' : 'updated'));
              return true;
            })
            .catch(function (err) {
              return onError(err, keys).then(function () {
                return false;
              });
            });
        })
        .catch(function () {
          return false;
        })
        .then(function (ok) {
          if (!Object.keys(pending).length && notePending === null) setBusy(false);
          return ok;
        });
      return inflight;
    }

    function schedule(key, qty) {
      pending[key] = qty;
      setBusy(true);
      window.clearTimeout(timer);
      timer = window.setTimeout(flush, 320);
    }

    function setQty(line, qty) {
      var input = q('[data-onys-qty]', line);
      var minus = q('[data-onys-minus]', line);
      input.value = String(qty);
      if (minus) minus.setAttribute('aria-disabled', qty <= 1 ? 'true' : 'false');
      input.classList.remove('is-bump');
      void input.offsetWidth;
      input.classList.add('is-bump');
      var err = q('.onys-cart__error', line);
      if (err) err.hidden = true;
      schedule(line.getAttribute('data-key'), qty);
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var plus = t.closest('[data-onys-plus]');
      var minus = t.closest('[data-onys-minus]');
      if (plus || minus) {
        e.preventDefault();
        var line = t.closest('.onys-cart__line');
        var input = q('[data-onys-qty]', line);
        var next = (parseInt(input.value, 10) || 0) + (plus ? 1 : -1);
        if (next >= 1) setQty(line, next);
        return;
      }

      var remove = t.closest('[data-onys-remove]');
      if (remove) {
        e.preventDefault();
        var row = remove.closest('.onys-cart__line');
        collapse(row);
        removed += 1;
        schedule(row.getAttribute('data-key'), 0);
        return;
      }

      if (t.closest('[name="update"]')) {
        e.preventDefault();
        flush();
        return;
      }

      if (t.closest('[name="checkout"]')) {
        e.preventDefault();
        setBusy(true);
        flush().then(function (ok) {
          if (ok) window.location.href = checkoutUrl;
        });
      }
    });

    root.addEventListener('change', function (e) {
      var input = e.target && e.target.closest ? e.target.closest('[data-onys-qty]') : null;
      if (!input) return;
      var line = input.closest('.onys-cart__line');
      var value = parseInt(input.value, 10);
      if (isNaN(value) || value < 0) {
        input.value = input.defaultValue;
        return;
      }
      if (value === 0) {
        collapse(line);
        schedule(line.getAttribute('data-key'), 0);
        return;
      }
      setQty(line, value);
    });

    root.addEventListener('input', function (e) {
      var area = e.target && e.target.name === 'note' ? e.target : null;
      if (!area) return;
      notePending = area.value;
      setBusy(true);
      window.clearTimeout(noteTimer);
      noteTimer = window.setTimeout(flush, 700);
    });

    root.addEventListener('submit', function (e) {
      e.preventDefault();
    });

    observeBar();
  }

  /* ---------- dithered emblem ---------- */
  /* The mark (or an uploaded logo) is rendered to a small grid, turned into on/off dots with
     Floyd-Steinberg error diffusion, and every dot becomes a particle. Particles are pushed away
     from the cursor, rippled by clicks, and spring back home. The loop only runs while something
     is moving: at rest nothing is scheduled at all. */
  var DITHER_STAR = 'M24 8l3.5 12.5L40 24l-12.5 3.5L24 40l-3.5-12.5L8 24l12.5-3.5z';
  var DITHER_BRACKETS = 'M4 14V4h10M34 4h10v10M44 34v10H34M14 44H4V34';

  function floydSteinberg(lum, size) {
    var on = new Uint8Array(size * size);
    for (var y = 0; y < size; y++) {
      var ltr = y % 2 === 0; /* serpentine scan avoids diagonal streaks */
      var dir = ltr ? 1 : -1;
      for (var i = 0; i < size; i++) {
        var x = ltr ? i : size - 1 - i;
        var idx = y * size + x;
        var value = lum[idx];
        var bit = value > 0.5 ? 1 : 0;
        on[idx] = bit;
        var err = value - bit;
        if (x + dir >= 0 && x + dir < size) lum[idx + dir] += (err * 7) / 16;
        if (y + 1 < size) {
          if (x - dir >= 0 && x - dir < size) lum[idx + size - dir] += (err * 3) / 16;
          lum[idx + size] += (err * 5) / 16;
          if (x + dir >= 0 && x + dir < size) lum[idx + size + dir] += err / 16;
        }
      }
    }
    return on;
  }

  function initDither() {
    var root = document.documentElement;
    [].slice.call(document.querySelectorAll('canvas[data-onys-dither]:not([data-onys-bound])')).forEach(function (canvas) {
      canvas.setAttribute('data-onys-bound', '');
      var ctx = canvas.getContext('2d');
      var host = canvas.parentElement;
      var emblem = canvas.closest('.onys-emblem');
      if (!ctx || !host || !emblem) return;

      var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      var lite = root.classList.contains('onys-lite');
      var G = lite ? 88 : window.innerWidth < 760 ? 110 : 150; /* dot grid: about 4000 / 2100 / 1500 dots */

      /* physics is in grid units, so a resize never has to touch the particles */
      var R = G * 0.19; /* cursor radius */
      var HOLE = 0.45; /* how far the middle of the cursor area is pushed, as a share of R */
      var RIPPLE_SPEED = G * 0.0009; /* grid units per ms */
      var RIPPLE_BAND = G * 0.095;
      var RIPPLE_LIFE = 1400;
      var RIPPLE_AMP = G * 0.09;
      var GATHER_MS = 1500; /* the first seconds are softer, so the dots drift in */
      var gatherEnd = 0;

      var n = 0;
      var gx;
      var gy;
      var px;
      var py;
      var vx;
      var vy;
      var spring;
      var ang;
      var buckets = [[], [], []];
      var ripples = [];
      var pointer = { x: 0, y: 0, on: false };
      var running = false;
      var visible = true;
      var raf = 0;
      var last = 0;
      var ready = false;

      function state(name) {
        canvas.setAttribute('data-state', name);
      }

      function sourceCanvas() {
        var off = document.createElement('canvas');
        off.width = off.height = G;
        return off;
      }

      /* the default mark: a soft halo, a star with a gradient (so it stipples) and the four corner brackets */
      function drawMark(off) {
        var c = off.getContext('2d');
        var k = (G * 0.66) / 48;
        var o = (G - 48 * k) / 2;
        c.translate(o, o);
        c.scale(k, k);
        var halo = c.createRadialGradient(24, 24, 0, 24, 24, 30);
        halo.addColorStop(0, 'rgba(255,255,255,0.6)');
        halo.addColorStop(0.55, 'rgba(255,255,255,0.18)');
        halo.addColorStop(1, 'rgba(255,255,255,0)');
        c.fillStyle = halo;
        c.fillRect(-8, -8, 64, 64);
        var starFill = c.createRadialGradient(24, 24, 0, 24, 24, 17);
        starFill.addColorStop(0, '#fff');
        starFill.addColorStop(1, 'rgba(255,255,255,0.6)');
        c.fillStyle = starFill;
        c.fill(new Path2D(DITHER_STAR));
        c.strokeStyle = '#fff';
        c.lineWidth = 1.7;
        c.stroke(new Path2D(DITHER_BRACKETS));
      }

      function drawImage(off, img) {
        var c = off.getContext('2d');
        var m = G * 0.08;
        var box = G - m * 2;
        var scale = Math.min(box / img.naturalWidth, box / img.naturalHeight);
        var w = img.naturalWidth * scale;
        var h = img.naturalHeight * scale;
        c.drawImage(img, (G - w) / 2, (G - h) / 2, w, h);
      }

      function luminance(off) {
        var data = off.getContext('2d').getImageData(0, 0, G, G).data;
        var lum = new Float32Array(G * G);
        for (var i = 0; i < G * G; i++) {
          var a = data[i * 4 + 3] / 255;
          var l = (0.2126 * data[i * 4] + 0.7152 * data[i * 4 + 1] + 0.0722 * data[i * 4 + 2]) / 255;
          lum[i] = a * l;
        }
        return lum;
      }

      function build(lum) {
        var original = Float32Array.from(lum);
        var on = floydSteinberg(lum, G);
        var count = 0;
        var i;
        for (i = 0; i < on.length; i++) count += on[i];
        n = count;
        gx = new Float32Array(n);
        gy = new Float32Array(n);
        px = new Float32Array(n);
        py = new Float32Array(n);
        vx = new Float32Array(n);
        vy = new Float32Array(n);
        spring = new Float32Array(n);
        ang = new Float32Array(n);
        buckets = [[], [], []];
        var j = 0;
        for (i = 0; i < on.length; i++) {
          if (!on[i]) continue;
          gx[j] = (i % G) + 0.5;
          gy[j] = Math.floor(i / G) + 0.5;
          spring[j] = 0.1 + Math.random() * 0.05;
          ang[j] = Math.random() * Math.PI * 2;
          var b = original[i] > 0.8 ? 2 : original[i] > 0.4 ? 1 : 0; /* brighter cells draw more opaque */
          buckets[b].push(j);
          j++;
        }
        canvas.setAttribute('data-particles', String(n));
      }

      function fit() {
        var css = host.offsetWidth || 300;
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var size = Math.round(css * dpr);
        if (canvas.width !== size) {
          canvas.width = size;
          canvas.height = size;
        }
      }

      var ALPHA = [0.5, 0.78, 1];
      function draw() {
        var W = canvas.width;
        var scale = W / G;
        var dot = Math.max(1, scale * 0.8);
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, W, W);
        for (var b = 0; b < 3; b++) {
          var list = buckets[b];
          if (!list.length) continue;
          ctx.fillStyle = 'rgba(241,231,211,' + ALPHA[b] + ')';
          ctx.beginPath();
          for (var k = 0; k < list.length; k++) {
            var i = list[k];
            ctx.rect(px[i] * scale - dot / 2, py[i] * scale - dot / 2, dot, dot);
          }
          ctx.fill();
        }
      }

      function snapHome() {
        for (var i = 0; i < n; i++) {
          px[i] = gx[i];
          py[i] = gy[i];
          vx[i] = 0;
          vy[i] = 0;
        }
      }

      /* Every dot has a target: its home, shifted by the cursor and by any ripple passing through.
         The dot springs towards that target. When the targets stop changing, everything settles fast. */
      function step(dt, now) {
        var s = dt / 16.667;
        var damp = Math.pow(0.78, s);
        var kScale = now < gatherEnd ? 0.4 : 1;
        var R2 = R * R;
        var i;
        var r;
        for (r = ripples.length - 1; r >= 0; r--) {
          ripples[r].age = now - ripples[r].t0;
          if (ripples[r].age > RIPPLE_LIFE) ripples.splice(r, 1);
        }
        var rc = ripples.length;
        for (r = 0; r < rc; r++) {
          ripples[r].radius = ripples[r].age * RIPPLE_SPEED;
          ripples[r].fade = 1 - ripples[r].age / RIPPLE_LIFE;
        }
        var maxSpeed = 0;
        var maxErr = 0;
        for (i = 0; i < n; i++) {
          var hx = gx[i];
          var hy = gy[i];
          var tx = hx;
          var ty = hy;
          if (pointer.on) {
            var dx = hx - pointer.x;
            var dy = hy - pointer.y;
            var d2 = dx * dx + dy * dy;
            if (d2 < R2) {
              var d = Math.sqrt(d2);
              var u = 1 - d / R;
              var m = R * HOLE * u * u;
              if (d < 0.001) {
                tx += Math.cos(ang[i]) * m;
                ty += Math.sin(ang[i]) * m;
              } else {
                tx += (dx / d) * m;
                ty += (dy / d) * m;
              }
            }
          }
          for (r = 0; r < rc; r++) {
            var rp = ripples[r];
            var rx = hx - rp.x;
            var ry = hy - rp.y;
            var rd = Math.sqrt(rx * rx + ry * ry) || 0.0001;
            var off = Math.abs(rd - rp.radius);
            if (off < RIPPLE_BAND) {
              var w = 1 - off / RIPPLE_BAND;
              var rm = RIPPLE_AMP * rp.fade * w * w;
              tx += (rx / rd) * rm;
              ty += (ry / rd) * rm;
            }
          }
          var k = spring[i] * kScale;
          var x = px[i];
          var y = py[i];
          var nvx = (vx[i] + (tx - x) * k * s) * damp;
          var nvy = (vy[i] + (ty - y) * k * s) * damp;
          vx[i] = nvx;
          vy[i] = nvy;
          px[i] = x + nvx * s;
          py[i] = y + nvy * s;
          var sp = Math.abs(nvx) + Math.abs(nvy);
          if (sp > maxSpeed) maxSpeed = sp;
          var err = Math.abs(tx - px[i]) + Math.abs(ty - py[i]);
          if (err > maxErr) maxErr = err;
        }
        return { speed: maxSpeed, err: maxErr };
      }

      function stop() {
        running = false;
        window.cancelAnimationFrame(raf);
        raf = 0;
        state('idle');
      }

      function frame(now) {
        raf = 0;
        if (!running) return;
        var dt = Math.min(now - last, 32);
        last = now;
        var e = step(dt, now);
        draw();
        /* settled = nothing is moving and every dot is on its target (0.03 grid units is ~0.05 css px) */
        var settled = e.speed < 0.03 && e.err < 0.06 && !ripples.length;
        if (settled) {
          if (!pointer.on) {
            snapHome();
            draw();
          }
          stop();
        } else {
          raf = window.requestAnimationFrame(frame);
        }
      }

      function wake() {
        if (running || !visible || !ready) return;
        running = true;
        last = window.performance.now();
        state('active');
        raf = window.requestAnimationFrame(frame);
      }

      function toGrid(clientX, clientY) {
        var r = canvas.getBoundingClientRect();
        return { x: ((clientX - r.left) / r.width) * G, y: ((clientY - r.top) / r.height) * G, inside: clientX >= r.left && clientX <= r.right && clientY >= r.top && clientY <= r.bottom };
      }

      function listen() {
        window.addEventListener(
          'pointermove',
          function (e) {
            if (!visible || e.pointerType === 'touch') return;
            var g = toGrid(e.clientX, e.clientY);
            var near = g.x > -R && g.x < G + R && g.y > -R && g.y < G + R;
            if (near) {
              pointer.x = g.x;
              pointer.y = g.y;
              if (!pointer.on) pointer.on = true;
              wake();
            } else if (pointer.on) {
              pointer.on = false;
              wake();
            }
          },
          { passive: true }
        );
        document.documentElement.addEventListener('pointerleave', function () {
          if (pointer.on) {
            pointer.on = false;
            wake();
          }
        });
        canvas.addEventListener('pointerdown', function (e) {
          var g = toGrid(e.clientX, e.clientY);
          if (ripples.length > 3) ripples.shift();
          ripples.push({ x: g.x, y: g.y, t0: window.performance.now(), age: 0, radius: 0, fade: 1 });
          if (e.pointerType === 'touch') {
            pointer.x = g.x;
            pointer.y = g.y;
            pointer.on = true;
          }
          wake();
        });
        var release = function (e) {
          if (e.pointerType === 'touch' && pointer.on) {
            pointer.on = false;
            wake();
          }
        };
        canvas.addEventListener('pointerup', release);
        canvas.addEventListener('pointercancel', release);

        if ('ResizeObserver' in window) {
          new ResizeObserver(function () {
            fit();
            draw();
          }).observe(host);
        }
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            visible = entries[0].isIntersecting;
            if (visible) wake();
            else if (running) stop();
          }).observe(canvas);
        }
      }

      function start(lum) {
        build(lum);
        fit();
        canvas.hidden = false;
        emblem.classList.add('is-dithered');
        ready = true;
        if (reduce) {
          snapHome();
          draw();
          state('idle');
          return;
        }
        /* the dots gather from a scatter */
        for (var i = 0; i < n; i++) {
          var a = Math.random() * Math.PI * 2;
          var d = G * (0.25 + Math.random() * 0.55);
          px[i] = gx[i] + Math.cos(a) * d;
          py[i] = gy[i] + Math.sin(a) * d;
        }
        draw();
        gatherEnd = window.performance.now() + GATHER_MS;
        listen();
        wake();
      }

      try {
        var src = canvas.getAttribute('data-src');
        var off = sourceCanvas();
        if (src) {
          var img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = function () {
            try {
              drawImage(off, img);
              start(luminance(off));
            } catch (err) {
              /* a tainted canvas or a broken image: keep the static logo */
            }
          };
          img.onerror = function () {};
          img.src = src;
        } else {
          drawMark(off);
          start(luminance(off));
        }
      } catch (err) {
        /* keep the static mark */
      }
    });
  }

  function init() {
    initMenu();
    initReveal();
    initBackdrops();
    initSpot();
    initVideos();
    initGallery();
    initSplit();
    initCart();
    initDither();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  /* Shopify theme editor re-renders sections */
  document.addEventListener('shopify:section:load', init);
})();
